import { stringify } from 'qs';
import { publicClient, privateClient, eldoradoClient, eldoradoBrandClient } from './client';

export const createSession = code => publicClient.post('/session', JSON.stringify({ code }));

export const getSubscription = token => privateClient(token).get(`/subscription/info`);

export const requestSubscription = (sessionToken, product, token, cvv) =>
  privateClient(sessionToken).post(`/subscription`, {
    produto: product,
    cartao: { token, cvv },
  });

export const requestUpdateCard = (sessionToken, token, cvv) =>
  privateClient(sessionToken).put(`/updateCard`, {
    cartao: { token, cvv },
  });

export const fetchBrands = () => eldoradoBrandClient.get();

export const requestTokenization = (pan, month, year) =>
  eldoradoClient.post('/v1/cc', stringify({ pan, month, year }));

export const getProducts = token => privateClient(token).get(`/products`);

export const requestUpdateProduct = (sessionToken, product) =>
  privateClient(sessionToken).put(`/updateProduct`, {
    produto: product,
  });

export const requestPixSessionToken = token => privateClient(token).get(`/pix/sessionToken`);
